/**
 * @file: description
 * @author:
 * @Date: 2020-04-13 15:59:08
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-04-27 15:24:25
 */
import React from 'react';
import './SFCSelected.less';
import { Link } from 'react-router-dom';
import { SubjectVO } from '@src/services';

export interface ISFCSelectedProps {
  data: SubjectVO;
}
type Props = ISFCSelectedProps;

export function SFCSelected(props: Readonly<Props>) {
  const { data } = props;

  return (
    <Link
      target="_blank"
      className="common-presenter k-selected-item"
      to={`/thematic/home-page/${data.id}`}
    >
      <img src={data.avatarImg} alt="" className="topic-avatar" />
      <div className="topic-bottom">
        <h2 className="topic-name">{data.title}</h2>
        <p className="topic-article-num">{data.articleAmount}篇文章</p>
      </div>
    </Link>
  );
}

export default SFCSelected;
